import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.ProviderStatementBalanceEmailTemplate.List.IRequest;
type Response = Api.Core.ProviderStatementBalanceEmailTemplate.List.IResponse;
type Headers = Api.Core.ProviderStatementBalanceEmailTemplate.List.IHeaders;
const url = '/api/Management/ProviderStatementBalanceEmailTemplate';
export default async function providerStatementBalanceEmailTemplateListApi(body?: Request): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.get,
    url,
    body,
    headers: getDefaultHeaders(),
  });
}
